import { Pipe, PipeTransform } from '@angular/core';
import { Media, MediaType } from '@epicuro-next/models/engagement';

const YOUTUBE_ID_MATCHER =
  /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/gi;

@Pipe({
  name: 'youtubeThumbnail',
  standalone: false,
})
export class YoutubeThumbnailPipe implements PipeTransform {
  public transform(media: Media): Media {
    if (media?.mediaType !== MediaType.Youtube) {
      return media;
    }

    const videoId = this.getYoutubeId(media.url);

    if (!videoId) {
      return media;
    }

    return {
      ...media,
      url: this.generateThumbnail(videoId),
      mediaType: MediaType.Image,
    };
  }

  private getYoutubeId(youtubeUrl: string) {
    const match = youtubeUrl.split(YOUTUBE_ID_MATCHER);
    if (match && match.length > 1) {
      return match[1];
    }
    return null;
  }

  private generateThumbnail(youtubeVideoId: string) {
    return `https://i.ytimg.com/vi/${youtubeVideoId}/hqdefault.jpg`;
  }
}
